module.exports = __webpack_public_path__ + "static/media/menu-live-stats-icon.b16007af.svg";